import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_DOCUMENT, ADD_DOCUMENT_FAILED, ADD_DOCUMENT_SUCCESS, DOCUMENT, DOCUMENT_FAILED, DOCUMENT_SUCCESS, UPDATE_DOCUMENT, UPDATE_DOCUMENT_FAILED, UPDATE_DOCUMENT_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"


export const getDocuments = () => async (dispatch) => {
  dispatch({
    type: DOCUMENT,
  });
  try {
    let response = await api(`document/documentList`, "get", {}, getAuthHeader());
    dispatch({
      type: DOCUMENT_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Document list error ====>", error);
    return dispatch({
      type: DOCUMENT_FAILED,
      payload: error?.message,
    });
  }
};

export const addDocument = (data) => async dispatch => {
  dispatch({
    type: ADD_DOCUMENT
  })
  try {
    let response = await api(`document/add`, 'post', data, getAuthHeader())
    console.log('add document data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_DOCUMENT_SUCCESS,
      payload: response?.data
    })
    await dispatch(getDocuments())
    return response
  } catch (error) {
    console.log("while Adding document error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_DOCUMENT_FAILED,
      payload: error?.message
    })
  }
}

export const updateDocument = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_DOCUMENT
  })
  try {
    let response = await api(`document/update/${id}`, 'put', data, getAuthHeader())
    console.log('update document data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_DOCUMENT_SUCCESS,
      payload: response?.data
    })
      await dispatch(getDocuments())
    return response
  } catch (error) {
    console.log("while updating document error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_DOCUMENT_FAILED,
      payload: error?.message
    })
  }
}